import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isWeCom, isWeChat } from '@/utils/wecom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Smartphone, AlertCircle, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
const WecomCheck: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // 检查是否在企微环境
    if (isWeCom) {
      // 在企微环境，跳转到静默登录页面
      navigate('/auth/silent-login', { replace: true });
    } else if (isWeChat) {
      // 在微信环境，提示用户切换到企微
      // toast.error('当前在微信环境，需要切换到企微');
      console.log('当前在微信环境，需要切换到企微');
    } else {
      // 不在企微环境，显示提示页面
      // toast.error('当前不在企微环境，需要切换到企微');
      console.log('当前不在企微环境，需要切换到企微');
    }
  }, [navigate]);

  const handleRetry = () => {
    // 重新检查环境
    window.location.reload();
  };

  const handleOpenInWecom = () => {
    // 这里可以添加打开企微的逻辑
    // 比如显示二维码或者跳转到企微下载页面
    toast.error('请从企业微信客户端打开此页面');
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-blue-100">
            <Smartphone className="h-8 w-8 text-blue-600" />
          </div>
          <CardTitle className="text-2xl font-bold text-gray-900">
            {isWeChat ? '请在企微中打开' : '环境检测'}
          </CardTitle>
          <CardDescription className="text-gray-600">
            {isWeChat
              ? '检测到您在微信中打开，请切换到企业微信客户端'
              : '请从企业微信客户端打开此页面以获得最佳体验'}
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-4">
          {isWeChat ? (
            <div className="space-y-3">
              <div className="flex items-start gap-3 rounded-lg bg-orange-50 p-3">
                <AlertCircle className="mt-0.5 h-5 w-5 text-orange-500" />
                <div className="text-sm text-orange-700">
                  <p className="font-medium">当前环境：微信</p>
                  <p>此应用需要在企业微信环境中运行</p>
                </div>
              </div>

              <div className="space-y-2">
                <Button onClick={handleOpenInWecom} className="w-full">
                  切换到企微打开
                </Button>
                <Button onClick={handleRetry} variant="outline" className="w-full">
                  <RefreshCw className="mr-2 h-4 w-4" />
                  重新检测
                </Button>
              </div>
            </div>
          ) : (
            <div className="space-y-3">
              <div className="flex items-center gap-3 rounded-lg bg-red-50 p-3">
                <AlertCircle className="mt-0.5 h-5 w-5 text-red-500" size={12} />
                <div className="text-sm text-red-700">
                  <p>环境不支持，请在企业微信客户端中打开此页面</p>
                </div>
              </div>

              <div className="space-y-2">
                <Button onClick={handleOpenInWecom} className="w-full">
                  打开企微
                </Button>
                <Button onClick={handleRetry} variant="outline" className="w-full">
                  <RefreshCw className="mr-2 h-4 w-4" />
                  重新检测
                </Button>
              </div>
            </div>
          )}

          <div className="text-center text-xs text-gray-500">
            <p>如果问题持续存在，请联系技术支持</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default WecomCheck;
